import { render, staticRenderFns } from "./crudCardList.vue?vue&type=template&id=33e25080"
import script from "./crudCardList.vue?vue&type=script&lang=js"
export * from "./crudCardList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports